<mat-list-item *ngIf="showSlider" class="top-spacer">
    <div mat-list-icon class="fake-icon-spacer">
    </div>
    <div [ngStyle]="{'height': nestSliderSize * 1.1 + 'px'}">
        <dl-nest-slider
                [size]="nestSliderSize"
                [(coolingSetpoint)]="coolingSetpoint"
                [(heatingSetpoint)]="heatingSetpoint"
                [setpointMinimum]="setpointMinimum"
                [setpointMaximum]="setpointMaximum"
                [temperature]="temperature"
                [relativeHumidity]="relativeHumidity"
                [handleOriginTransformX]="nestSliderOriginX"
                [handleOriginTransformY]="nestSliderOriginY"
                [enabled]="isEditMode"
                [whiteMode]="heating || cooling"
                [ngStyle]="{'position': 'absolute'}"
                (coolingSetpointDebouncedChange)="onCoolingSetpointDebouncedChange($event)"
                (heatingSetpointDebouncedChange)="onHeatingSetpointDebouncedChange($event)"
        ></dl-nest-slider>
    </div>
</mat-list-item>
<mat-list-item *ngIf="isEditMode && occupied !== undefined" class="edit-divider min-height top-spacer">
    <div mat-list-icon class="fake-icon-spacer">
    </div>
    <div fxFlex class="bottom-padding">
        <mat-button-toggle-group
                [(ngModel)]="occupied"
                (change)="onOccupiedChange($event)"
               >
            <mat-button-toggle [value]="true">
                <mat-icon>person</mat-icon>
                Occupied
            </mat-button-toggle>
            <mat-button-toggle [value]="false">
                <mat-icon>person_outline</mat-icon>
                Unoccupied
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</mat-list-item>
